import { range } from 'lodash';
import moment from 'moment';

import formatDate from './formatDate.es6';

export default ({ startDate, endDate }) =>
  range(
    (endDate
      ? moment(endDate)
      : moment(startDate)
          .add(1, 'month')
          .subtract(1, 'day')
    ) // no end => is current period
      .diff(moment(startDate), 'days') + 1
  )
    .map(index => moment(startDate).add(index, 'days'))
    .map(formatDate);



// WEBPACK FOOTER //
// ./src/javascripts/account/usage/committed/periodToDates.es6.js